import gql from 'graphql-tag'
import { priceLevels, cashFlow, kitchen, order } from './fragments'

export default gql`
	query getAppConfig {
		cashAssist {
			getAppConfig {
				...priceLevels
				...cashFlow
				...kitchen
				...order
				taraName
			}
		}
	}
	${priceLevels}
	${cashFlow}
	${kitchen}
	${order}
`
